
import { Vue, Component, Prop } from 'vue-property-decorator';
import Model from './model';
import Common from "../../commonUtil/common";
import Login from "../../components/model";

// 必须使用@Component注解
@Component
export default class TbUserEditVue extends Vue {
  private model = new Model();
  private common = new Common();
  private login = new Login();


  private data = {
      id: '',
      username: '',
      password: '',
      newPassword: '',
      newPasswordTwo: ''
  }

  // 校验参数是否正确
  private async checkParam() {
    if (this.data.newPassword != this.data.newPasswordTwo) {
      Vue.prototype.$message.warning('两侧输入的密码不一致');
      return false;
    } else {
      return true;
    }
  }

  // 修改密码
  private async editPassword() {
    const flag = await this.checkParam();
    if (flag === false) {
      return ;
    }

    let paramT: any = {
      data:{
        id: this.data.id,
      },
      equalMap: {
        password: this.data.password,
        newPassword: this.data.newPassword,
      }
    }
    const result = await this.model.editPassword(paramT);
    if (result) {
      if (result.code == 200) {
        Vue.prototype.$message.success('修改成功！');

        localStorage.removeItem('myuser');
        this.login.logout({});
        this.$router.push({ path: '/login', query: {} });
        
      } else {
        Vue.prototype.$message.error(result.message);
      }
    } else {
      Vue.prototype.$message.error('服务异常');
    }
  }

     // 跳转到上一页
  private async goHistory() {
    this.$router.go(-1);
  }

  private async mounted() {
    const myuser: any = await this.common.getMyuser();
    this.data.id = myuser.id;
    this.data.username = myuser.username;
    
  }

}
